import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string'
import { fetchMetricsData, fetchCompareMetricsData, downloadMetricsData, loadSessionfromSSET} from '../../State/actions/sessions';
import * as Constants from '../../State/constants/CommonConstants';

import Box from 'grommet/components/Box';
import Tabs from 'grommet/components/Tabs';
import Tab from 'grommet/components/Tab';
import Heading from 'grommet/components/Heading';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import Layer from 'grommet/components/Layer';
import Table from 'grommet/components/Table';
//import TableHeader from 'grommet/components/TableHeader';
import TableRow from 'grommet/components/TableRow';
import Paragraph from 'grommet/components/Paragraph';
import Spinning from 'grommet/components/icons/Spinning'
let getSSETData = false;
//import Metricsdata from '../../Datafiles/Metricsdata_Latest1'

let list = [];
let tempMetricsData;
class MetricsData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ActvSolution: '',
      ActvSolutionObj: '',
      SolutionsList: [],
      showCompareSoln: false,
      TCOSelection: '',
      dataManipulation: {
        Performance: [true, true, true, true, true],
        Capacity: [true, true, true, true, true],
        Density: [true, true, true, true],
        Cost: [true, true, true, true],
        Power: [true],
        CapacityDefaults: { ReplicationDiskCapacity: null, Erasure6DiskCapacity: null },
        DensityDefaults: { ComputePerf: null, StorageThroughput: null, ReplicationDiskCapacity: null, Erasure6DiskCapacity: null },
        CostDefaults: { CPUPerf: null, RawStoragecapacity: null, ReplicationStoragecapacity: null, ErasureStoragecapacity: null },
        PowerDefaults: { CPUPerf: null },
        FunctionType: '',
        TagType: '',
        Servicelayer: false
      },
      dataManipulationExtra: {
        Performance: [true, true, true, true, true],
        Capacity: [true, true, true, true, true],
        Density: [true, true, true, true],
        Cost: [true, true, true, true],
        Power: [true],
        CapacityDefaults: { ReplicationDiskCapacity: null, Erasure6DiskCapacity: null },
        DensityDefaults: { ComputePerf: null, StorageThroughput: null, ReplicationDiskCapacity: null, Erasure6DiskCapacity: null },
        CostDefaults: { CPUPerf: null, RawStoragecapacity: null, ReplicationStoragecapacity: null, ErasureStoragecapacity: null },
        PowerDefaults: { CPUPerf: null }
      }

    };
    this.onActvSolutionChange = this.onActvSolutionChange.bind(this);
    this.onExport = this.onExport.bind(this);
    this.onTCOChange = this.onTCOChange.bind(this);
    this.manipulateData = this.manipulateData.bind(this);
    this.manipulateDataExtra = this.manipulateDataExtra.bind(this);
    this.Serviceleveldata = this.Serviceleveldata.bind(this)
    this.ServiceDataClose = this.ServiceDataClose.bind(this)
  }

  // componentWillMount(){
  // }

  // componentWillReceiveProps(nextProps){

  //   if(this.props.MetricsData !== nextProps.MetricsData){
  //     this.state.ActvSolution = nextProps.MetricsData.Values.Value[0]['@Header'];
  //     this.state.ActvSolutionObj = nextProps.MetricsData.Values.Value[0];
  //     console.log(nextProps.CompareMetricsData);
  //     nextProps.MetricsData.Values.Value.map( (item, index) => {      
  //       if(item['TotalCost']['#text'] !== '' && item['TotalCost']['#text'] !== undefined ){
  //         list.push(item['@Header']);
  //       }      
  //     });
  //     if(nextProps.MetricsData.Values.Value.length > 1){
  //       list.push('Compare Metrics Data');
  //     }        
  //     this.setState ({SolutionsList: list });
  //   }

  // }

  manipulateData(index, component, metrics) {
    var data = this.state.dataManipulation;
    var actvSol = this.state.ActvSolutionObj;
    var value;
    switch (component) {
      case 'Performance': data.Performance[index] = !data.Performance[index];
        actvSol['Performance']['Item'].map((item, itemIndex) => {
          if (itemIndex === index) {
            switch (metrics) {
              case 'CPU Performance': data.Performance[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dStorageSpecINT) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dStorageSpecINT)
                item['#text'] = value; break;
              case 'Storage Throughput': data.Performance[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dComputeThroughPut) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dComputeThroughPut)
                item['#text'] = value; break;
              case 'Storage Read IOPS': data.Performance[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dComputeReadIOPS) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dComputeReadIOPS)
                item['#text'] = value; break;
              case 'Storage Write IOPS': data.Performance[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dComputeWriteIOPS) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dComputeWriteIOPS)
                item['#text'] = value; break;
            }
          }
        }); break;
      case 'Capacity': data.Capacity[index] = !data.Capacity[index];
        actvSol['Capacity']['Item'].map((item, itemIndex) => {
          if (itemIndex === index) {
            switch (metrics) {
              case 'Cores': data.Capacity[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.iStorageCores) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.iStorageCores)
                item['#text'] = value; break;
              case 'Memory': data.Capacity[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.iStorageMemory) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.iStorageMemory)
                item['#text'] = value; break;
              case 'Raw Disk Capacity': if (data.Capacity[index]) {
                value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dComputeDiskCapacity.toFixed(2))
              }
              else {
                value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dComputeDiskCapacity.toFixed(2));
              }
                item['#text'] = value; break;
              case 'Replication Disk Capacity': data.Capacity[index] ? value = parseFloat(data.CapacityDefaults.ReplicationDiskCapacity) :
                value = parseFloat(((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression).toFixed(2));
                if (data.CapacityDefaults.ReplicationDiskCapacity === null) {
                  data.CapacityDefaults.ReplicationDiskCapacity = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Erasure 6:3 Disk Capacity': data.Capacity[index] ? value = parseFloat(data.CapacityDefaults.Erasure6DiskCapacity) :
                value = parseFloat(((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression).toFixed(2))
                if (data.CapacityDefaults.Erasure6DiskCapacity === null) {
                  data.CapacityDefaults.Erasure6DiskCapacity = item['#text']
                }
                item['#text'] = value; break;
            }
          }
        }); break;
      case 'Density Metrics': data.Density[index] = !data.Density[index];
        actvSol['DensityMetrics']['Item'].map((item, itemIndex) => {
          if (itemIndex === index) {
            switch (metrics) {
              case 'Compute Perf': data.Density[index] ? value = parseFloat(data.DensityDefaults.ComputePerf) :
                value = (parseFloat(this.props.MetricsData.manipulationData.dComputeSpecINT) / parseFloat(this.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);
                if (data.DensityDefaults.ComputePerf === null) {
                  data.DensityDefaults.ComputePerf = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Raw Data Capacity': data.Density[index] ? value = parseFloat(data.DensityDefaults.StorageThroughput) :
                value = (parseFloat(this.props.MetricsData.manipulationData.dStorageDiskCapacity).toFixed(2) / parseFloat(this.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);
                if (data.DensityDefaults.StorageThroughput === null) {
                  data.DensityDefaults.StorageThroughput = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Replication Data Capacity': data.Density[index] ? value = parseFloat(data.DensityDefaults.ReplicationDiskCapacity) :
                value = parseFloat((((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);
                if (data.DensityDefaults.ReplicationDiskCapacity === null) {
                  data.DensityDefaults.ReplicationDiskCapacity = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Erasure 6:3 Data Capacity': data.Density[index] ? value = parseFloat(data.DensityDefaults.Erasure6DiskCapacity) :
                value = parseFloat((((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);
                if (data.DensityDefaults.Erasure6DiskCapacity === null) {
                  data.DensityDefaults.Erasure6DiskCapacity = item['#text']
                }
                item['#text'] = value; break;
            }
          }
        });
        break;
      case 'Cost Metrics': data.Cost[index] = !data.Cost[index];
        actvSol['CostMetrics']['Item'].map((item, itemIndex) => {
          if (itemIndex === index) {
            switch (metrics) {
              case 'CPU Perf/Price': data.Cost[index] ? value = parseFloat(data.CostDefaults.CPUPerf) :
                value = parseFloat((this.props.MetricsData.manipulationData.dComputeSpecINT / this.props.MetricsData.manipulationData.dTotalCost) * 1000).toFixed(2);
                if (data.CostDefaults.CPUPerf === null) {
                  data.CostDefaults.CPUPerf = item['#text']
                }
                item['#text'] = value;
                break;

              case 'Raw Storage capacity/Price': data.Cost[index] ? value = parseFloat(data.CostDefaults.RawStoragecapacity) :
                value = parseFloat((this.props.MetricsData.manipulationData.dStorageDiskCapacity / this.props.MetricsData.manipulationData.dTotalCost) * 1000).toFixed(2);
                if (data.CostDefaults.RawStoragecapacity === null) {
                  data.CostDefaults.RawStoragecapacity = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Replication Storage capacity/Price': data.Cost[index] ? value = parseFloat(data.CostDefaults.ReplicationStoragecapacity) :
                value = parseFloat((((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.dTotalCost) * 1000).toFixed(2);
                if (data.CostDefaults.ReplicationStoragecapacity === null) {
                  data.CostDefaults.ReplicationStoragecapacity = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Erasure 6:3 Storage capacity/Price': data.Cost[index] ? value = parseFloat(data.CostDefaults.ErasureStoragecapacity) :
                value = parseFloat((((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.dTotalCost) * 1000).toFixed(2);
                if (data.CostDefaults.ErasureStoragecapacity === null) {
                  data.CostDefaults.ErasureStoragecapacity = item['#text']
                }
                item['#text'] = value;
                break;
            }
          }
        });
        break;
      case 'Power Metrics': data.Power[index] = !data.Power[index];
        actvSol['PowerMetrics']['Item'].map((item, itemIndex) => {
          if (itemIndex === index) {
            switch (metrics) {
              case 'CPU Perf/Watt': data.Power[index] ? value = parseFloat(data.PowerDefaults.CPUPerf) :
                value = parseFloat((this.props.MetricsData.manipulationData.dComputeSpecINT / this.props.MetricsData.manipulationData.dTotalPower) * 1000).toFixed(2);
                if (data.PowerDefaults.CPUPerf === null) {
                  data.PowerDefaults.CPUPerf = item['#text']
                }
                item['#text'] = value;
                break;
            }
          }
        });
    }
    this.setState({ dataManipulation: data, ActvSolutionObj: actvSol });
  }

  manipulateDataExtra(index, component, metrics) {
    var data = this.state.dataManipulationExtra;
    var actvSol = this.state.ActvSolutionObj;
    var value;
    switch (component) {
      case 'Performance': data.Performance[index] = !data.Performance[index];
        actvSol['Performance']['Item'].map((item, itemIndex) => {
          if (itemIndex === index) {
            switch (metrics) {
              case 'CPU Performance': data.Performance[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dExtraStorageSpecINT) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dExtraStorageSpecINT);
                item['#text'] = value; break;
              case 'Storage Throughput': data.Performance[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dExtraComputeThroughPut) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dExtraComputeThroughPut)
                item['#text'] = value; break;
              case 'Storage Read IOPS': data.Performance[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dExtraComputeReadIOPS) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dExtraComputeReadIOPS)
                item['#text'] = value; break;
              case 'Storage Write IOPS': data.Performance[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dExtraComputeWriteIOPS) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dExtraComputeWriteIOPS)
                item['#text'] = value; break;
            }
          }
        }); break;
      case 'Capacity': data.Capacity[index] = !data.Capacity[index];
        actvSol['Capacity']['Item'].map((item, itemIndex) => {
          if (itemIndex === index) {
            switch (metrics) {
              case 'Cores': data.Capacity[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.iExtraStorageCores) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.iExtraStorageCores)
                item['#text'] = value; break;
              case 'Memory': data.Capacity[index] ? value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.iExtraStorageMemory) : value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.iExtraStorageMemory)
                item['#text'] = value; break;
              case 'Raw Disk Capacity': if (data.Capacity[index]) {
                value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity.toFixed(2))
              }
              else {
                value = parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity.toFixed(2));
              }
                item['#text'] = value; break;
              case 'Replication Disk Capacity': data.Capacity[index] ? value = parseFloat(data.CapacityDefaults.ReplicationDiskCapacity) :
                value = parseFloat(((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression).toFixed(2));
                if (data.CapacityDefaults.ReplicationDiskCapacity === null) {
                  data.CapacityDefaults.ReplicationDiskCapacity = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Erasure 6:3 Disk Capacity': data.Capacity[index] ? value = parseFloat(data.CapacityDefaults.Erasure6DiskCapacity) :
                value = parseFloat(((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression).toFixed(2))
                if (data.CapacityDefaults.Erasure6DiskCapacity === null) {
                  data.CapacityDefaults.Erasure6DiskCapacity = item['#text']
                }
                item['#text'] = value; break;
            }
          }
        }); break;
      case 'Density Metrics': data.Density[index] = !data.Density[index];
        actvSol['DensityMetrics']['Item'].map((item, itemIndex) => {
          if (itemIndex === index) {
            switch (metrics) {
              case 'Compute Perf': data.Density[index] ? value = parseFloat(data.DensityDefaults.ComputePerf) :
                value = (parseFloat(this.props.MetricsData.manipulationData.dExtraComputeSpecINT - this.props.MetricsData.manipulationData.dExtraStorageSpecINT) / parseFloat(this.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);
                if (data.DensityDefaults.ComputePerf === null) {
                  data.DensityDefaults.ComputePerf = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Raw Data Capacity': data.Density[index] ? value = parseFloat(data.DensityDefaults.StorageThroughput) :
                value = (parseFloat(this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity).toFixed(2) / parseFloat(this.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);
                if (data.DensityDefaults.StorageThroughput === null) {
                  data.DensityDefaults.StorageThroughput = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Replication Data Capacity': data.Density[index] ? value = parseFloat(data.DensityDefaults.ReplicationDiskCapacity) :
                value = parseFloat((((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);
                if (data.DensityDefaults.ReplicationDiskCapacity === null) {
                  data.DensityDefaults.ReplicationDiskCapacity = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Erasure 6:3 Data Capacity': data.Density[index] ? value = parseFloat(data.DensityDefaults.Erasure6DiskCapacity) :
                value = parseFloat((((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);
                if (data.DensityDefaults.Erasure6DiskCapacity === null) {
                  data.DensityDefaults.Erasure6DiskCapacity = item['#text']
                }
                item['#text'] = value; break;
            }
          }
        });
        break;
      case 'Cost Metrics': data.Cost[index] = !data.Cost[index];
        actvSol['CostMetrics']['Item'].map((item, itemIndex) => {
          if (itemIndex === index) {
            switch (metrics) {
              case 'CPU Perf/Price': data.Cost[index] ? value = parseFloat(data.CostDefaults.CPUPerf) :
                value = parseFloat(((this.props.MetricsData.manipulationData.dExtraComputeSpecINT - this.props.MetricsData.manipulationData.dExtraStorageSpecINT) / this.props.MetricsData.manipulationData.dExtraTotalCost) * 1000).toFixed(2);
                if (data.CostDefaults.CPUPerf === null) {
                  data.CostDefaults.CPUPerf = item['#text']
                }
                item['#text'] = value;
                break;

              case 'Raw Storage capacity/Price': data.Cost[index] ? value = parseFloat(data.CostDefaults.RawStoragecapacity) :
                value = parseFloat((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity / this.props.MetricsData.manipulationData.dExtraTotalCost) * 1000).toFixed(2);
                if (data.CostDefaults.RawStoragecapacity === null) {
                  data.CostDefaults.RawStoragecapacity = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Replication Storage capacity/Price': data.Cost[index] ? value = parseFloat(data.CostDefaults.ReplicationStoragecapacity) :
                value = parseFloat((((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.dExtraTotalCost) * 1000).toFixed(2);
                if (data.CostDefaults.ReplicationStoragecapacity === null) {
                  data.CostDefaults.ReplicationStoragecapacity = item['#text']
                }
                item['#text'] = value;
                break;
              case 'Erasure 6:3 Storage capacity/Price': data.Cost[index] ? value = parseFloat(data.CostDefaults.ErasureStoragecapacity) :
                value = parseFloat((((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.dExtraTotalCost) * 1000).toFixed(2);
                if (data.CostDefaults.ErasureStoragecapacity === null) {
                  data.CostDefaults.ErasureStoragecapacity = item['#text']
                }
                item['#text'] = value;
                break;
            }
          }
        });
        break;
      case 'Power Metrics': data.Power[index] = !data.Power[index];
        actvSol['PowerMetrics']['Item'].map((item, itemIndex) => {
          if (itemIndex === index) {
            switch (metrics) {
              case 'CPU Perf/Watt': data.Power[index] ? value = parseFloat(data.PowerDefaults.CPUPerf) :
                value = Math.round(parseFloat(((this.props.MetricsData.manipulationData.dExtraComputeSpecINT - this.props.MetricsData.manipulationData.dExtraStorageSpecINT) / this.props.MetricsData.manipulationData.dTotalExtraPower) * 1000));
                if (data.PowerDefaults.CPUPerf === null) {
                  data.PowerDefaults.CPUPerf = item['#text']
                }
                item['#text'] = value;
                break;
            }
          }
        });
    }
    this.setState({ dataManipulation: data, ActvSolutionObj: actvSol });
  }

  componentWillMount() {
    //this.props.onFetchMetricsData({ 'SessionID': this.props.activeSession.id });
    // this.props.onFetchCompareMetricsData({ 'SessionID': this.props.activeSession.id });
  }

  componentDidMount() {
    //   this.props.onFetchCompareMetricsData({'SessionID': this.props.activeSession.id});
    if(!this.props.activeSession  ||  this.props.activeSession.MetricsData=='') {
      if (this.props.externalAppProps && this.props.isFromExternalApp) {
        getSSETData = true;
        let queryParameter = queryString.parse(window.location.search);
        let sessionObject = { "SessionID": queryParameter.sizerReference };
        this.props.onFetchMetricsData(sessionObject);
      }
    }

  }

  componentWillReceiveProps(nextProps) {
    list = [];
    if (!this.props.FactoryExpressdata.workload.UserInputs) {
      if (this.props.isFromExternalApp) {
        let queryParameter = queryString.parse(window.location.search);
        let userData = {
          "reference": queryParameter.reference,
          "isSizerAsEntry": queryParameter.isSizerAsEntry ? true : false
        };
        if (nextProps.sessionDefaults && nextProps.sessionDefaults.workload && getSSETData) {
          getSSETData = false;
          if (this.props.activeSession.MetricsData !== '') {
            tempMetricsData = this.props.activeSession.MetricsData;
          }
          this.props.getSSETData(userData);
        }
      }
      if (nextProps.activeSession && nextProps.activeSession.workload) {
        const obj = nextProps.activeSession.workload;
        this.props.onNewSession(obj);
      }
    }
    if (this.props.MetricsData !== nextProps.MetricsData && nextProps.MetricsData.output) {
      // this.state.ActvSolution = nextProps.MetricsData.output.Values.Value[0]['@Header'];
      // this.state.ActvSolutionObj = nextProps.MetricsData.output.Values.Value[0];
        this.state.ActvSolution = nextProps.MetricsData.output.Values.Value['@Header'];
      this.state.ActvSolutionObj = nextProps.MetricsData.output.Values.Value;
      console.log(this.props.CompareMetricsData);

      if(Array.isArray(nextProps.MetricsData.output.Values.Value)){
      nextProps.MetricsData.output.Values.Value.map((item, index) => {
        if (item['TotalCost']['#text'] !== '' && item['TotalCost']['#text'] !== undefined && item['@Header'] !== 'Traditional') {
          list.push(item['@Header']);
        }
      });
      }else{
         list.push(nextProps.MetricsData.output.Values.Value['@Header']);
      }
      // this.state.ActvSolution = nextProps.MetricsData.output.Values.Value[0]['@Header'];
      // this.state.ActvSolutionObj = nextProps.MetricsData.output.Values.Value[0];
      // if(nextProps.MetricsData.output.Values.Value.length > 1){
      //   list.push('Compare Metrics Data');
      // }
      //  if(nextProps.activeSession.EPAArray.length >0){
      //     list.push('Compare Metrics Data');
      //   }
      //   if (this.props.CompareMetricsData !== nextProps.CompareMetricsData ) {
      //      this.props.onFetchCompareMetricsData({ 'SessionID': this.props.activeSession.id });
      // }
      this.setState({ SolutionsList: list });
    }
  }

  onActvSolutionChange(e) {
    // if (e.value === 'Compare Metrics Data') {

    //   if (this.props.CompareMetricsData === '') {
    //     this.props.onFetchCompareMetricsData({ 'SessionID': this.props.activeSession.id });
    //   }
    //   this.setState({ ActvSolution: e.value, showCompareSoln: true });
    // } else {
    //   this.props.MetricsData.output.Values.Value.map((item, index) => {
    //     if (item['@Header'] === e.value) {
    //       this.state.ActvSolutionObj = item;
    //     }
    //   });
    //   this.setState({ ActvSolution: e.value, showCompareSoln: false });
    // }
  }

  onExport() {

    var data;
    if (this.state.ActvSolution === 'Compare Metrics Data') {

      var obj = {
        root: {
          element: JSON.parse(JSON.stringify(this.props.CompareMetricsData)),
          additionalInfo: {
            isCompareSolution: true
          }
        }
      }
      // var root = {
      //   root :obj
      // }
      data = {
        "Data": obj
      };
    }
    else {
      var filter;
      if (tempMetricsData !== undefined) {
        filter = JSON.parse(JSON.stringify(tempMetricsData.output));
      } else {
        filter = JSON.parse(JSON.stringify(this.props.MetricsData.output));
      }


      //filter = JSON.parse(JSON.stringify(this.props.MetricsData.output));
      var temp;
      var content;
      if (Array.isArray(filter.Values.Value)) {
        filter.Values.Value.forEach((item) => {
          if (item['@Header'] === this.state.ActvSolution) {
            temp = item;
          }
        });
        if (temp !== undefined) {
          filter.Values.Value = [];
          filter.Values.Value.push(temp);
        }
        content = {
          root: {
            filter: filter,
            additionalInfo: {
              FactoryExpress: this.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress,
              isCompareSolution: false
            }
          }
        }
      }else{
         content = {
          root: {
            filter: filter,
            additionalInfo: {
              FactoryExpress: this.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress,
              isCompareSolution: false
            }
          }
        }
      }
      data = {
        "Data": content
      };
    }

    this.props.onExportMetricsData(data);
  }

  onTCOChange(e) {
    var val = '';
    this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map((item, index) => {
      if (item['@Text'] === e.value)
        val = item['#text'];
    });
    this.setState({ TCOValue: val, TCOSelection: e.value });
  }
  ServiceDataClose(e) {
    this.setState({ Servicelayer: false })
  }
  Serviceleveldata(e, FunctionService, Type) {
    this.setState({ Servicelayer: true, FunctionType: FunctionService, TagType: Type })
  }
  render() {

    let MainData = '';
    let tblRowStyle = { border: '1px solid #ccc' };
    let tblRowBoldStyle = { border: '1px solid #ccc', fontWeight: 'bold' };
    let tbltdStyle = { padding: '5px', textAlign: 'left', width: '10px !important' };
    let tbltdStyle_btn = { padding: '0px', textAlign: 'left', borderColor: 'white' };
    let btnStyle = { padding: '0px', textAlign: 'left', background: 'rgb(255, 141, 109)', border: '1px solid', color: 'white', marginLeft: '5px' };
    let tbltdBoldStyle = { padding: '5px', textAlign: 'left', width: '80px !important', fontWeight: 'bold' };

    let totalcostItems = '';
    let mainTotalCost = '';
    let TCOList = [];
    let TCOItems = '';
    let FactoryExpress = '';
    let FactoryExpressPerc = '';

    let perfItems = [];
    let performancedata = [];
    let TotalCostMetricsdata = [];
    let TotalCostMetricsItems = [];
    let capacitydata = [];
    let densitydata = [];
    let costdata = [];
    let powerdata = [];
    let capacityItems = [];
    let densityItems = [];
    let costItems = [];
    let powerItems = [];
    let rackItems = [];

    let performancedatafunctions = []
    let perfItemsfunction = [];
    let ServiceName = ''

    // Compare Metrics Variables
    let compareMetricsItems = '';

    let LoadingLayer = '';
    if (this.props.isLoading && this.props.LoadingMsg !== '') {
      // LoadingLayer = <Layer className='Metricsdatalayer' style={{ zIndex: '500 !important' }}>
      //   <Box direction='row' style={{ padding: '40px' }} size='medium' pad={{ 'between': 'small' }}>
      //     <Spinning size='small' />
      //     <Heading tag='h5' margin='none'>{this.props.LoadingMsg}</Heading>
      //   </Box>
      // </Layer>
      MainData = <Box direction='row' pad={{ 'between': 'small' }} style={{ alignSelf: 'center', marginTop: '16%', fontWeight: '600' }}> <Spinning size='small' style={{ marginRight: '3px' }} />{this.props.LoadingMsg}</Box>
    }

    if (this.state.ActvSolutionObj !== '' && this.props.FactoryExpressdata.workload.UserInputs) {
      totalcostItems = this.state.ActvSolutionObj['TotalCostMetrics']['Item'].map((item, index) => {
        return <TableRow key={index} style={tblRowStyle} >
          <td style={tbltdStyle} >{item['@Text']}</td>
          <td style={tbltdStyle} >{item['@Unit']}</td>
          <td style={tbltdStyle} >{item['#text']}</td>
        </TableRow>
      });

      mainTotalCost = <TableRow style={tblRowBoldStyle} >
        <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCost']['@Text']}</td>
        <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']}</td>
        <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCost']['#text']}</td>
      </TableRow>

      if (this.state.TCOSelection === '') {
        this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map((item, index) => {
          TCOList.push(item['@Text']);
        });
        this.state.TCOSelection = TCOList[0];
        this.state.TCOValue = this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'][0]['#text'];
      } else {
        this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map((item, index) => {
          TCOList.push(item['@Text']);
        });
      }

      if (this.props.FactoryExpressdata.workload.UserInputs) {
      var FEOptCost = '';
      var FEOptPerc = '';
      this.state.ActvSolutionObj['ComboOptions']['FEOptionsCost']['Item'].filter((item, index) => {
        if (item['@Text'] === this.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress) {
          FEOptCost = item['#text'];
        }
      });
      this.state.ActvSolutionObj['ComboOptions']['FEOptionsPerc']['Item'].filter((item, index) => {
        if (item['@Text'] === this.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress) {
          FEOptPerc = item['#text'];
        }
      })

      FactoryExpress = <TableRow style={tblRowBoldStyle} >
        <td style={tbltdStyle} >{this.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress}</td>
        {/*   <td style={tbltdStyle} >{this.state.ActvSolutionObj['ComboOptions']['FEOptionsCost']['@Unit']}</td>*/}
        <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']}</td>
        <td style={tbltdStyle} >{FEOptCost}</td>
      </TableRow>

      FactoryExpressPerc = <TableRow style={tblRowBoldStyle} >
        <td style={tbltdStyle} >{this.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress}</td>
        <td style={tbltdStyle} >{this.state.ActvSolutionObj['ComboOptions']['FEOptionsPerc']['@Unit']}</td>
        {/* <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']}</td>*/}
        <td style={tbltdStyle} >{FEOptPerc}</td>
      </TableRow>
      }


      TCOItems = <TableRow style={tblRowBoldStyle} >
        <td style={tbltdStyle} > <Select options={TCOList}
          onChange={this.onTCOChange}
          value={this.state.TCOSelection} /> </td>
        {/* <td style={tbltdStyle} >{this.state.ActvSolutionObj['ComboOptions']['TCO']['@Unit']}</td>*/}
        <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']}</td>
        <td style={tbltdStyle} >{this.state.TCOValue}</td>
      </TableRow>

      if (this.props.CompareMetricsData !== '' && !this.props.isLoading) {
        compareMetricsItems = this.props.CompareMetricsData.map((metItem, index) => {
          if ((metItem['Unit'] === null && metItem['Metrics'] !== ' ') || (metItem['Unit'] === " " && metItem['Metrics'] !== ' ')) {
            return <TableRow key={index} style={tblRowBoldStyle} rowSpan='4' >
              <th style={tbltdBoldStyle} >{metItem['Metrics']}</th>
            </TableRow>
          } else if (metItem['Metrics'] !== ' ' && metItem['Unit'] !== null) {
            return <TableRow key={index} style={tblRowStyle} >
              <td style={tbltdStyle} >{metItem['Metrics']}</td>
              <td style={tbltdStyle} >{metItem['Unit']}</td>
              <td style={tbltdStyle} >{metItem['WDO_Config']}</td>
              <td style={tbltdStyle} >{metItem['Traditional_Nodes']}</td>
            </TableRow>
          }
        });
      }

      let metricsHeading = Constants.EPA_METRICS_HEADER;
      if(this.props.FactoryExpressdata.workload.UserInputs && this.props.FactoryExpressdata.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
        metricsHeading = Constants.EZMERALCP_METRICS_HEADER;
      }
      switch (this.state.ActvSolutionObj['@Header']) {
        case metricsHeading: {
          let butn = ""
          let functionName = ''
          this.state.ActvSolutionObj['TotalCostMetrics']['Function'].map((item, index) => {
            if (Array.isArray(item.Service)) {
              item.Service.map((service) => {
                functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box><Box onClick={(e) => { this.Serviceleveldata(e, item['@Name'], 'TotalCostMetrics') } } style={{ textDecoration: 'underline', marginLeft: '5px' }}>(View service level data)</Box></Box>
                if (service['@Type'] === "Total" && (service['@TotalCost'] !== "0" ||service.Item[0]['#text'] !== "0") ){
                  TotalCostMetricsItems = service.Item.map((text) => {
                    return <TableRow style={tblRowStyle} >
                      <td style={tbltdStyle} >{text['@Text']}</td>
                      <td style={tbltdStyle} >{text['@Unit']}</td>
                      <td style={tbltdStyle} >{text['#text']}</td>
                    </TableRow>

                  })
                  TotalCostMetricsdata.push(<tbody>
                    <TableRow>
                      {functionName}
                    </TableRow>
                    {TotalCostMetricsItems}
                  </tbody>)
                }
              })
            } else {
              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box></Box>
         if (item.Service['@Type'] === "Total"&& (item.Service['@TotalCost'] !== "0"||item.Service.Item[0]['#text'] !== "0")) {
                TotalCostMetricsItems = item.Service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>

                })
                TotalCostMetricsdata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {TotalCostMetricsItems}
                </tbody>)
              }

            }


          })
          this.state.ActvSolutionObj['Performance']['Function'].map((item, index) => {
            if (Array.isArray(item.Service)) {
              item.Service.map((service) => {
                functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box><Box onClick={(e) => { this.Serviceleveldata(e, item['@Name'], 'Performance') } } style={{ textDecoration: 'underline', marginLeft: '5px' }}>(View service level data)</Box></Box>
               if (service['@Type'] === "Total"&& (service['@TotalCost'] !== "0")) {
                if(service.Item[0]['#text'] !== "0"){
                  perfItems = service.Item.map((text) => {
                    return <TableRow style={tblRowStyle} >
                      <td style={tbltdStyle} >{text['@Text']}</td>
                      <td style={tbltdStyle} >{text['@Unit']}</td>
                      <td style={tbltdStyle} >{text['#text']}</td>
                    </TableRow>
                  })
                  performancedata.push(<tbody>
                    <TableRow>
                      {functionName}
                    </TableRow>
                    {perfItems}
                  </tbody>)
                }
              }
              })
            } else {

              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box></Box>
              if (item.Service['@Type'] === "Total"&& (item.Service['@TotalCost'] !== "0" )) {
                 if(item.Service.Item[0]['#text'] !== "0"){
                  perfItems =item.Service.Item.map((text) =>{ 
                    return<TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>
                  })
                performancedata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {perfItems}
                </tbody>)
              }
              }
            }

          })

          this.state.ActvSolutionObj['Capacity']['Function'].map((item, index) => {
            if (Array.isArray(item.Service)) {
              item.Service.map((service) => {
                functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box><Box onClick={(e) => { this.Serviceleveldata(e, item['@Name'], 'Capacity') } } style={{ textDecoration: 'underline', marginLeft: '5px' }}>(View service level data)</Box></Box>
                if (service['@Type'] === "Total"&& (service['@TotalCost'] !== "0" )) {
                 if(service.Item[0]['#text'] !== "0"){
                  capacityItems = service.Item.map((text) => {
                    return <TableRow style={tblRowStyle} >
                      <td style={tbltdStyle} >{text['@Text']}</td>
                      <td style={tbltdStyle} >{text['@Unit']}</td>
                      <td style={tbltdStyle} >{text['#text']}</td>
                    </TableRow>
                  })
                  capacitydata.push(<tbody>
                    <TableRow>
                      {functionName}
                    </TableRow>
                    {capacityItems}
                  </tbody>)
                }
                }
              })
            } else {

              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box></Box>
              if (item.Service['@Type'] === "Total"&& (item.Service['@TotalCost'] !== "0" )) {
                 if(item.Service.Item[0]['#text'] !== "0"){
                capacityItems = item.Service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>
                })
                capacitydata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {capacityItems}
                </tbody>)
                 }
              }

            }
          })
          this.state.ActvSolutionObj['DensityMetrics']['Function'].map((item, index) => {
            if (Array.isArray(item.Service)) {
              item.Service.map((service) => {
                functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box><Box onClick={(e) => { this.Serviceleveldata(e, item['@Name'], 'DensityMetrics') } } style={{ textDecoration: 'underline', marginLeft: '5px' }}>(View service level data)</Box></Box>
                if (service['@Type'] === "Total"&& (service['@TotalCost'] !== "0")) {
                 if(service.Item[0]['#text'] !== "0"){
                  densityItems = service.Item.map((text) => {
                    return <TableRow style={tblRowStyle} >
                      <td style={tbltdStyle} >{text['@Text']}</td>
                      <td style={tbltdStyle} >{text['@Unit']}</td>
                      <td style={tbltdStyle} >{text['#text']}</td>
                    </TableRow>
                  })
                  densitydata.push(<tbody>
                    <TableRow>
                      {functionName}
                    </TableRow>
                    {densityItems}
                  </tbody>)
                }
                }
              })
            } else {

              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box></Box>
              if (item.Service['@Type'] === "Total"&& (item.Service['@TotalCost'] !== "0")) {
                 if(item.Service.Item[0]['#text'] !== "0"){
                densityItems = item.Service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>
                })
                densitydata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {densityItems}
                </tbody>)
              }
              }

            }
          })
          this.state.ActvSolutionObj['CostMetrics']['Function'].map((item, index) => {
            if (Array.isArray(item.Service)) {
              item.Service.map((service) => {
                functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box><Box onClick={(e) => { this.Serviceleveldata(e, item['@Name'], 'CostMetrics') } } style={{ textDecoration: 'underline', marginLeft: '5px' }}>(View service level data)</Box></Box>
                if (service['@Type'] === "Total"&& (service['@TotalCost'] !== "0" ||service.Item[0]['#text'] !== "0")) {
                  if(service.Item[0]['#text'] !== "0"){
                  costItems = service.Item.map((text) => {
                    return <TableRow style={tblRowStyle} >
                      <td style={tbltdStyle} >{text['@Text']}</td>
                      <td style={tbltdStyle} >{text['@Unit']}</td>
                      <td style={tbltdStyle} >{text['#text']}</td>
                    </TableRow>
                  })
                  costdata.push(<tbody>
                    <TableRow>
                      {functionName}
                    </TableRow>
                    {costItems}
                  </tbody>)
                }
                }
              })
            } else {

              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box></Box>
              if (item.Service['@Type'] === "Total"&& (item.Service['@TotalCost'] !== "0")) {
                  if(item.Service.Item[0]['#text'] !== "0"){
                costItems = item.Service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>
                })
                costdata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {costItems}
                </tbody>)
              }
              }
            }
          })
          this.state.ActvSolutionObj['PowerMetrics']['Function'].map((item, index) => {
            if (Array.isArray(item.Service)) {
              item.Service.map((service) => {
                functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box><Box onClick={(e) => { this.Serviceleveldata(e, item['@Name'], 'PowerMetrics') } } style={{ textDecoration: 'underline', marginLeft: '5px' }}>(View service level data)</Box></Box>
                if (service['@Type'] === "Total"&& (service['@TotalCost'] !== "0")) {
                 if(service.Item[0]['#text'] !== "0"){
                  powerItems = service.Item.map((text) => {
                    return <TableRow style={tblRowStyle} >
                      <td style={tbltdStyle} >{text['@Text']}</td>
                      <td style={tbltdStyle} >{text['@Unit']}</td>
                      <td style={tbltdStyle} >{text['#text']}</td>
                      {butn}
                    </TableRow>
                  })
                  powerdata.push(<tbody>
                    <TableRow>
                      {functionName}
                    </TableRow>
                    {powerItems}
                  </tbody>)
                }
                }
              })
            } else {

              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{item['@Name']}</Box></Box>
              if (item.Service['@Type'] === "Total"&& (item.Service['@TotalCost'] !== "0")) {
                 if(item.Service.Item[0]['#text'] !== "0"){
                powerItems = item.Service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                    {butn}
                  </TableRow>
                })
                powerdata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {powerItems}
                </tbody>)
              }
              }
            }
          })
          rackItems = this.state.ActvSolutionObj['RackSpace']['Item'].map((item, index) => {
            return <TableRow style={tblRowStyle} >
              <td style={tbltdStyle} >{item['@Text']}</td>
              <td style={tbltdStyle} >{item['@Unit']}</td>
              <td style={tbltdStyle} >{item['#text']}</td>
            </TableRow>
          })

          break;
        }

        case 'Extra Nodes': {
          let butn = ""
          perfItems = this.state.ActvSolutionObj['Performance']['Item'].map((item, index) => {
            var text = '';
            this.state.dataManipulationExtra.Performance[index] ? text = 'Remove' : text = 'Add';
            item['@Text'].indexOf('Performance') > 0 ? text += ' Custom' : text += ' Edge';
            // butn = this.props.MetricsData.manipulationData="" ? "":<td style={tbltdStyle_btn} ><Button plain={true} style={btnStyle} label={text} onClick={()=>{this.manipulateDataExtra(index,'Performance',item['@Text'])}}/></td>  
            return <TableRow style={tblRowStyle} >
              <td style={tbltdStyle} >{item['@Text']}</td>
              <td style={tbltdStyle} >{item['@Unit']}</td>
              <td style={tbltdStyle} >{item['#text']}</td>
              {this.props.MetricsData.manipulationData === "" ? "" : <td style={tbltdStyle_btn} ><Button plain={true} style={btnStyle} label={text} onClick={() => { this.manipulateDataExtra(index, 'Performance', item['@Text']) } } /></td>}
            </TableRow>
          })
          capacityItems = this.state.ActvSolutionObj['Capacity']['Item'].map((item, index) => {
            var text = '';
            this.state.dataManipulationExtra.Capacity[index] ? text = 'Remove' : text = 'Add';
            item['@Text'].indexOf('Capacity') > 0 ? text += ' Edge' : text += ' Custom';

            return <TableRow style={tblRowStyle} >
              <td style={tbltdStyle} >{item['@Text']}</td>
              <td style={tbltdStyle} >{item['@Unit']}</td>
              <td style={tbltdStyle} >{item['#text']}</td>
              {this.props.MetricsData.manipulationData === "" ? "" : <td style={tbltdStyle_btn} ><Button plain={true} style={btnStyle} label={text} onClick={() => { this.manipulateDataExtra(index, 'Capacity', item['@Text']) } } /></td>}
            </TableRow>
          })
          densityItems = this.state.ActvSolutionObj['DensityMetrics']['Item'].map((item, index) => {
            var text = '';
            this.state.dataManipulationExtra.Density[index] ? text = 'Remove' : text = 'Add';
            item['@Text'].indexOf('Capacity') > 0 ? text += ' Edge' : text += ' Custom';
            butn = this.props.MetricsData.manipulationData === "" ? "" : <td style={tbltdStyle_btn} ><Button label={text} plain={true} style={btnStyle} onClick={() => { this.manipulateDataExtra(index, 'Density Metrics', item['@Text']) } } /></td>
            return <TableRow style={tblRowStyle} >
              <td style={tbltdStyle} >{item['@Text']}</td>
              <td style={tbltdStyle} >{item['@Unit']}</td>
              <td style={tbltdStyle} >{item['#text']}</td>
              {this.state.dataManipulationExtra.Density[index] !== undefined ? butn : ''}
            </TableRow>
          })
          costItems = this.state.ActvSolutionObj['CostMetrics']['Item'].map((item, index) => {
            var text = '';
            this.state.dataManipulationExtra.Cost[index] ? text = 'Remove' : text = 'Add';
            item['@Text'].indexOf('capacity') > 0 ? text += ' Edge' : text += ' Custom';
            butn = this.props.MetricsData.manipulationData === "" ? "" : <td style={tbltdStyle_btn} ><Button label={text} plain={true} style={btnStyle} onClick={() => { this.manipulateDataExtra(index, 'Cost Metrics', item['@Text']) } } /></td>
            return <TableRow style={tblRowStyle} >
              <td style={tbltdStyle} >{item['@Text']}</td>
              <td style={tbltdStyle} >{item['@Unit']}</td>
              <td style={tbltdStyle} >{item['#text']}</td>
              {this.state.dataManipulationExtra.Cost[index] !== undefined ? butn : ''}
            </TableRow>
          })
          powerItems = this.state.ActvSolutionObj['PowerMetrics']['Item'].map((item, index) => {
            var text = '';
            this.state.dataManipulationExtra.Power[index] ? text = 'Remove' : text = 'Add';
            text += ' Custom';
            butn = this.props.MetricsData.manipulationData === "" ? "" : <td style={tbltdStyle_btn} ><Button label={text} plain={true} style={btnStyle} onClick={() => { this.manipulateDataExtra(index, 'Power Metrics', item['@Text']) } } /></td>
            return <TableRow style={tblRowStyle} >
              <td style={tbltdStyle} >{item['@Text']}</td>
              <td style={tbltdStyle} >{item['@Unit']}</td>
              <td style={tbltdStyle} >{item['#text']}</td>
              {this.state.dataManipulationExtra.Power[index] !== undefined ? butn : ''}

            </TableRow>
          });
          break;
        }

        case 'Traditional': {
          let functionName = ''
          if (Array.isArray(this.state.ActvSolutionObj['TotalCostMetrics']['Function']['Service'])) {
            this.state.ActvSolutionObj['TotalCostMetrics']['Function']['Service'].map((service, index) => {
              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{service['@Type']}</Box></Box>
              if (service['@Type'] !== "Total") {
                TotalCostMetricsItems = service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>

                })
                TotalCostMetricsdata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {TotalCostMetricsItems}
                </tbody>)
              }
            })
          }
          if (Array.isArray(this.state.ActvSolutionObj['Performance']['Function']['Service'])) {
            this.state.ActvSolutionObj['Performance']['Function']['Service'].map((service, index) => {
              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{service['@Type']}</Box></Box>
              if (service['@Type'] !== "Total") {
                perfItems = service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>

                })
                performancedata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {perfItems}
                </tbody>)
              }
            })
          }
          if (Array.isArray(this.state.ActvSolutionObj['Capacity']['Function']['Service'])) {
            this.state.ActvSolutionObj['Capacity']['Function']['Service'].map((service, index) => {
              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{service['@Type']}</Box></Box>
              if (service['@Type'] !== "Total") {
                capacityItems = service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>

                })
                capacitydata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {capacityItems}
                </tbody>)
              }
            })
          }
          if (Array.isArray(this.state.ActvSolutionObj['DensityMetrics']['Function']['Service'])) {
            this.state.ActvSolutionObj['DensityMetrics']['Function']['Service'].map((service, index) => {
              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{service['@Type']}</Box></Box>
              if (service['@Type'] !== "Total") {
                densityItems = service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>

                })
                densitydata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {densityItems}
                </tbody>)
              }
            })
          }

          if (Array.isArray(this.state.ActvSolutionObj['CostMetrics']['Function']['Service'])) {
            this.state.ActvSolutionObj['CostMetrics']['Function']['Service'].map((service, index) => {
              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{service['@Type']}</Box></Box>
              if (service['@Type'] !== "Total") {
                costItems = service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>

                })
                costdata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {costItems}
                </tbody>)
              }
            })
          }
          if (Array.isArray(this.state.ActvSolutionObj['PowerMetrics']['Function']['Service'])) {
            this.state.ActvSolutionObj['PowerMetrics']['Function']['Service'].map((service, index) => {
              functionName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 0px' }}><Box>{service['@Type']}</Box></Box>
              if (service['@Type'] !== "Total") {
                powerItems = service.Item.map((text) => {
                  return <TableRow style={tblRowStyle} >
                    <td style={tbltdStyle} >{text['@Text']}</td>
                    <td style={tbltdStyle} >{text['@Unit']}</td>
                    <td style={tbltdStyle} >{text['#text']}</td>
                  </TableRow>

                })
                powerdata.push(<tbody>
                  <TableRow>
                    {functionName}
                  </TableRow>
                  {powerItems}
                </tbody>)
              }
            })
          }


          rackItems = this.state.ActvSolutionObj['RackSpace']['Item'].map((item, index) => {
            return <TableRow style={tblRowStyle} >
              <td style={tbltdStyle} >{item['@Text']}</td>
              <td style={tbltdStyle} >{item['@Unit']}</td>
              <td style={tbltdStyle} >{item['#text']}</td>
            </TableRow>

          })

          break;
        }

        default: break;
      }

      if (!this.state.showCompareSoln) {
        MainData =
          <Tabs justify='start' style={{ width: '100%' }}>
            <Tab title='Total Cost Metrics' style={{height:'100%',overFlow:'auto'}}>
              <Box direction='row'  className="TabInnerSection MetricsTable" margin="none" pad="none" justify='center' align='center'
                style={{  width: '100% !important', overflowX: 'hidden', overflowY: 'auto' }}>
              { /* <Table scrollable={true} style={{ marginTop: margintop }} >*/}
              <Table scrollable={true} style={{}}>
                  <thead><tr><th style={{ width: '35%' }}>Metrics</th><th style={{ width: '10%' }}>Unit</th><th style={{ width: '30%' }}>Value</th><th style={{ backgroundColor: 'white', border: 'white' }}></th></tr></thead>
                  {TotalCostMetricsdata}
                  <tbody>
                    {totalcostItems}
                    {mainTotalCost}
                    {FactoryExpress}
                    {FactoryExpressPerc}
                    {TCOItems}
                  </tbody>
                </Table>
              </Box>
            </Tab>
            <Tab title='Performance' >
              <Box direction='row'  className="TabInnerSection MetricsTable" margin="none" pad="none" justify='center' align='center'
                style={{width: '100% !important', overflowX: 'hidden', overflowY: 'auto' }}>
                <Table scrollable={true}  style={{}} >
                  <thead><tr><th style={{ width: '25%' }}>Metrics</th><th style={{ width: '10%' }}>Unit</th><th style={{ width: '20%' }}>Value</th><th style={{ backgroundColor: 'white', border: 'white' }}></th></tr></thead>
                  {performancedata}
                </Table>
              </Box>
            </Tab>
            <Tab title='Capacity' >
              <Box direction='row'  className="TabInnerSection MetricsTable" margin="none" pad="none" justify='center' align='center'
                style={{  width: '100% !important', overflowX: 'hidden', overflowY: 'auto' }}>
                <Table scrollable={true}  style={{}} >
                  <thead><tr><th style={{ width: '25%' }}>Metrics</th><th style={{ width: '10%' }}>Unit</th><th style={{ width: '20%' }}>Value</th><th style={{ backgroundColor: 'white', border: 'white' }}></th></tr></thead>
                  {capacitydata}
                </Table>
              </Box>
            </Tab>
            <Tab title='Density Metrics' >
              <Box direction='row' className="TabInnerSection MetricsTable" margin="none" pad="none" justify='center' align='center'
                style={{ width: '100% !important'}}>
                <Table scrollable={true}  style={{height:'500px'}} >
                  <thead><tr><th style={{ width: '25%' }}>Metrics</th><th style={{ width: '15%' }}>Unit</th><th style={{ width: '23%' }}>Value</th><th style={{ backgroundColor: 'white', border: 'white' }}></th></tr></thead>
                  {densitydata}
                </Table>
              </Box>
            </Tab>
            <Tab title='Cost Metrics' >
              <Box direction='row' className="TabInnerSection MetricsTable" margin="none" pad="none" justify='center' align='center'
                style={{ width: '100% !important'}}>
                <Table scrollable={true}  style={{height:'500px'}} >
                  <thead><tr><th style={{ width: '30%' }}>Metrics</th><th style={{ width: '15%' }}>Unit</th><th style={{ width: '20%' }}>Value</th><th style={{ backgroundColor: 'white', border: 'white' }}></th></tr></thead>
                  {costdata}
                </Table>
              </Box>
            </Tab>
            <Tab title='Power Metrics'>
              <Box direction='row'  className="TabInnerSection MetricsTable" margin="none" pad="none" justify='center' align='center'
                style={{  width: '100% !important' }}>
                <Table scrollable={true}  style={{}} >
                  <thead><tr><th style={{ width: '25%' }}>Metrics</th><th style={{ width: '25%' }}>Unit</th><th style={{ width: '20%' }}>Value</th><th style={{ backgroundColor: 'white', border: 'white' }}></th></tr></thead>
                  {powerdata}
                </Table>
              </Box>
            </Tab>
            <Tab title='Rack Space'>
              <Box direction='row' className="TabInnerSection MetricsTable_Button" margin="none" pad="none" justify='center' align='center' style={{ height: '100%', width: '100%!import' }}>
                <Table>
                  <thead><tr><th style={{ width: '25%' }}>Metrics</th><th style={{ width: '25%' }}>Unit</th><th style={{ width: '20%' }}>Value</th><th style={{ backgroundColor: 'white', border: 'white' }}></th></tr></thead>
                  <tbody>
                    {rackItems}
                  </tbody>
                </Table>
              </Box>
            </Tab>
          </Tabs>

      } else {
        if (this.props.CompareMetricsData !== '' && !this.props.isLoading) {
          MainData = <Box separator='bottom' className="TabInnerSection MetricsTable" margin="none" pad="none" justify='center' align='center'
            style={{ height: '600px', width: '50% !important', overflowX: 'hidden', overflowY: 'auto' }}>
            <Table className='marginClassforIe' scrollable={true} style={{ marginTop: '119px', height: '100%' }} >
              {/*<TableHeader labels={['Metrics', 'Unit', 'Elastic Config', 'Traditional Nodes']} />*/}
              <thead><tr><th>Metrics</th><th>Unit</th><th>Elastic Config</th><th>Traditional Nodes</th></tr></thead>
              <tbody>
                {compareMetricsItems}
              </tbody>
            </Table>
          </Box>
        }
      }
      var Data = ""
      if (this.state.Servicelayer) {
        let tag = ''
        tag = this.state.TagType
        this.state.ActvSolutionObj[tag]['Function'].map((item, index) => {
          if (Array.isArray(item.Service)) {
            item.Service.map((service) => {
              if (item['@Name'] === this.state.FunctionType && parseInt(item['TotalCost'], 10) !== 0 && item['TotalCost'] !== '') {
                if (service['@Type'] !== "Total" && service['@isSelected'] !== 'false') {
                  ServiceName = <Box direction='row' pad='none' margin='none' style={{ fontWeight: '600', margin: '5px 5px' }}>{service['@Type']}</Box>
                  perfItemsfunction = service.Item.map((text) => {
                    return <TableRow style={tblRowStyle} >
                      <td style={tbltdStyle} >{text['@Text']}</td>
                      <td style={tbltdStyle} >{text['@Unit']}</td>
                      <td style={tbltdStyle} >{text['#text']}</td>
                    </TableRow>
                  })
                  performancedatafunctions.push(<tbody>
                    <TableRow>
                      {ServiceName}
                    </TableRow>
                    {perfItemsfunction}
                  </tbody>)
                }
              }
            })
          } else {

          }
        })
        Data = <Layer className="MetricsDataServicePage" onClose={this.ServiceDataClose} closer={true} flush={false} style={{ width: '85% !imporatnt', zIndex: '10001 !important' }}>
          <Box className="TabInnerSection MetricsTable" margin="none" pad={{ 'between': 'small' }} justify='center' align='center' style={{ height: '100%', width: '100%! important', marginTop: '0px' }}>
            <Box style={{ width: '100%', alignItems: 'center' }}>
              {tag + "-" + this.state.FunctionType}
            </Box>
            <Box style={{ overflowY: 'auto', width: '100%', padding: '5px' }}>
              <Table>
                {/*<thead><tr><th style={{ width: '25%' }}>Metrics</th><th style={{ width: '10%' }}>Unit</th><th style={{ width: '20%' }}>Value</th><th style={{ backgroundColor: 'white', border: 'white' }}></th></tr></thead>*/}
                <thead><tr><th style={{ width: '25%' }}>Metrics</th><th style={{ width: '10%' }}>Unit</th><th style={{ width: '20%' }}>Value</th></tr></thead>
                {performancedatafunctions}
              </Table>
            </Box>
          </Box>
        </Layer>
      }
    }

    return (
      <Box margin="none" pad="small" style={{ width: '100% !important', height: '100%' }}>
        <Box direction='row' margin="none" pad={{ between: 'small' }} >
          <Heading tag='h5' margin='small' strong={false} >Solutions : </Heading>
          <Select onChange={this.onActvSolutionChange.bind(this)}
            options={this.state.SolutionsList} style={{ maxWidth: '225px' }}
            value={this.state.ActvSolution} />
          <Button label='Export to Excel' primary={true} onClick={this.onExport} style={{ height: '40px', marginTop: '3px' }} />
          {this.state.ActvSolution === 'Compare Metrics Data' ?
            <Paragraph style={{ margin: '12px 0px 0px 100px', color: 'red' }}>Note: Extra node values are included in Elastic config value.</Paragraph> : ''}
        </Box>
        {LoadingLayer}
        <Box margin="none" pad="none" style={{ width: '100% !important',height:'93%',overflowY:'auto' }}>
          {MainData}
        </Box>
        {Data}
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.sessions.isLoadingCompare,
    LoadingMsg: state.sessions.LoadingMsgCompare,
    activeSession: state.sessions.activeSession,
    MetricsData: state.sessions.activeSession.MetricsData,
    CompareMetricsData: state.sessions.activeSession.CompareMetricsData,
    FactoryExpressdata: state.sizerWorkload,
    sessionDefaults: state.sessions.sessionDefaults,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchMetricsData: (obj) => {
      dispatch(fetchMetricsData(obj));
    },
    onFetchCompareMetricsData: (obj) => {
      dispatch(fetchCompareMetricsData(obj));
    },
    onExportMetricsData: (data) => {
      dispatch(downloadMetricsData(data));
    },
    getSSETData: (userData) => { dispatch(loadSessionfromSSET(userData)) },
    onNewSession: (workload) => { dispatch({ type: 'UPDATE_SIZER_WORKLOAD', payload: workload }) },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MetricsData); 



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/MetricsData_vNext.js